import { render, staticRenderFns } from "./DocumentationPendingToCompleteIcon.vue?vue&type=template&id=64882082"
import script from "./DocumentationPendingToCompleteIcon.vue?vue&type=script&lang=js"
export * from "./DocumentationPendingToCompleteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports